import { createSlice } from "@reduxjs/toolkit";
import apiManagerRecordings from "api/recordings";
import { SLICE_NAME } from "constants/common";
import moment from "moment";
import store from "store/store";
import { getTotalSizeRecords } from "../hook/useHandleManagerRecording";
import { setShowBackdrop } from "store/commonSlice";
import { localLog } from "utils/functions/common";

export const fetchData = async (data) => {
    try {
        store.dispatch(setShowBackdrop(true))
        const res = await apiManagerRecordings.getRecordingByUser(data);

        const _meetings = res?.meetings.map(meeting => {
            return {
                ...meeting,
                totalSize: getTotalSizeRecords(meeting.recording_files)
            }
        })

        if (res?.page_size) {
            store.dispatch(setTableData({
                data: { ...res, meetings: _meetings },
                total: res.total_records
            }))
        }
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

export const fetchDataMyRecords = async (query) => {
    try {
        store.dispatch(setShowBackdrop(true))

        localLog("query get my record detail: ", query);

        const res = await apiManagerRecordings.getMyRecordDetail(query)
        if(res?.code === 0) {
            store.dispatch(setTableDataV2({
                data: res?.data,
                total: res?.total
            }))
        } else if(res?.data?.code === 0) {
            store.dispatch(setTableDataV2({
                data: res?.data?.data,
                total: res?.data?.total
            }))
        }
    } catch (error) {
        localLog("Error fetch data my records: ", error)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

export const fetchDataSharedUser = async (query) => {
    try {
        store.dispatch(setShowBackdrop(true))

        localLog("Query get shared user: ", query)

        const res = await apiManagerRecordings.getSharedUserList(query)

        if(res?.data?.code === 0) {
            store.dispatch(setRecord(res.data))
            store.dispatch(setTableDataSharedUser({
                data: res?.data?.data,
                total: res?.data?.total
            }))
        }
    } catch (error) {
        localLog("Error fetch data shared user: ", error)
    } finally {
        store.dispatch(setShowBackdrop(false))
    }
}

const initialState = {
    tableData: {
        data: [],
        total: 0
    },
    tableDataSharedUser: {
        data: [],
        total: 0
    },
    searchQuerySharedUser: {
        page: 0,
        size: 5,
        user_name: '',
        expire_status: ''
    },
    searchQuery: {
        groupCode: "",
        groupId: "",
        to: moment().endOf('day').format("YYYY-MM-DD"),
        from: moment().startOf('day').subtract(30, 'days').format("YYYY-MM-DD"),
        room_name: '',
        page_no: 0
    },
    searchQueryV2: { 
        started_date_from: moment().startOf('day').subtract(30, 'days').unix()*1000, 
        started_date_to: moment().endOf('day').unix()*1000, 
        recording_status: 1, 
        is_deleted: 0, 
        page: 0, 
        size: 5, 
        is_my_record: '', 
        room_name: '', 
        orderBy: 0, 
        orderType: 0 
    },
    tableDataV2: {
        data: [],
        total: 0
    },
    record: null,
    isRefreshTableDataV2: false,
    isRefreshTableDataSharedUser: false
}

export const managerRecordingSlice = createSlice({
    name: SLICE_NAME.MANAGER_RECORDING,
    initialState,
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void (state.searchQuery = action.payload),
        setTableDataV2: (state, action) => void (state.tableDataV2 = action.payload),
        setSearchQueryV2: (state, action) => void (state.searchQueryV2 = action.payload),
        setTableDataSharedUser: (state, action) => void (state.tableDataSharedUser = action.payload),
        setSearchQuerySharedUser: (state, action) => void (state.searchQuerySharedUser = action.payload),
        setRecord: (state, action) => void(state.record = action.payload),
        toggleRefreshTableDataV2: (state, action) => void(state.isRefreshTableDataV2 = !state.isRefreshTableDataV2),
        toggleRefreshTableDataSharedUser: (state, action) => void(state.isRefreshTableDataSharedUser = !state.isRefreshTableDataSharedUser),
        clearQueryRecording: (state, action) => {
            state.searchQueryV2 = { 
                started_date_from: moment().startOf('day').subtract(30, 'days').unix()*1000, 
                started_date_to: moment().endOf('day').unix()*1000, 
                recording_status: 1, 
                is_deleted: 0, 
                page: 0, 
                size: 5, 
                is_my_record: '', 
                room_name: '', 
                orderBy: 0, 
                orderType: 0 
            }
            state.searchQuerySharedUser = {
                page: 0,
                size: 5,
                user_name: '',
                expire_status: ''
            }
            state.record = null
        },
        clearQueryShareRecord: (state, action) => {
            state.searchQuerySharedUser = {
                page: 0,
                size: 5,
                user_name: '',
                expire_status: ''
            }
        }
    }
})

export const { setTableData, setSearchQuery, setTableDataV2, setSearchQueryV2, setSearchQuerySharedUser,setTableDataSharedUser, setRecord, toggleRefreshTableDataV2, toggleRefreshTableDataSharedUser, clearQueryRecording, clearQueryShareRecord } = managerRecordingSlice.actions
export default managerRecordingSlice.reducer